import { StaffBoardPost } from "../../../interfaces/StaffBoardPostInterface";

type Attachment = StaffBoardPost["attachments"][number];

const imageMimeTypes = ["image/jpeg", "image/gif", "image/png"];

export const isImageAttachment = (attachment: Attachment) => {
  return imageMimeTypes.includes(attachment.contentType);
};
